import styled from "@emotion/styled";
import { COLOR_ATHENS_GRAY_DARKER_2, COLOR_STALE_GRAY } from "../../constants/styles";
import { Box } from "../../UI/Box";
import { Typography } from "../../UI/Typography";

interface IProps {
  title: string;
  subtitle?: string;
  showTitleBackground?: boolean;
}

const SectionTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "showBackground",
})<{ showBackground?: boolean }>`
  padding: 1.5px 6px;
  background: ${({ showBackground }) => (showBackground ? COLOR_ATHENS_GRAY_DARKER_2 : "none")};
  border-radius: ${(prop) => prop.theme.shape.borderRadius + "px"};
`;

export const PlacementWorksheetRightPopupSectionContainer: React.FC<IProps> = (props) => {
  const { children, title, showTitleBackground, subtitle } = props;

  return (
    <Box px={1} py={2}>
      <SectionTitle variant="h6" showBackground={showTitleBackground}>
        {title}
      </SectionTitle>
      {subtitle && (
        <Typography variant="subtitle1" color={COLOR_STALE_GRAY} my={1}>
          {subtitle}
        </Typography>
      )}
      {children}
    </Box>
  );
};
